/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA1Icon24Regular = forwardRef('DataChartPieA1Icon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25a.75.75 0 0 0-.75.75v9a.75.75 0 0 0 1.125.65l7.794-4.5a.75.75 0 0 0 .275-1.025A9.75 9.75 0 0 0 12 2.25Zm.75 8.451V3.784a8.25 8.25 0 0 1 5.99 3.459L12.75 10.7Z" }),
        React.createElement("path", { d: "M9.026 4.305a.75.75 0 1 0-.54-1.4 9.75 9.75 0 1 0 13.172 7.757.75.75 0 0 0-1.486.205A8.249 8.249 0 1 1 9.026 4.305Z" })));
});
